import React from "react";
import { useT } from "../lib/i18n";

export default function ProjectLimitNotice({ planTier, current, limit, onClose }) {
  const t = useT();
  const needsEnterprise = planTier === "business";

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/70 p-4" data-testid="project-limit-overlay">
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="project-limit-title"
        className="grid-card w-full max-w-lg space-y-5 p-5 sm:p-7"
        data-testid="project-limit-dialog"
      >
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.18em] text-[var(--text-2)]">{t("plan.limit.label")}</p>
          <h2 id="project-limit-title" className="mt-2 text-2xl font-bold text-[var(--text)]">{t("plan.limit.title")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-[var(--text-2)]">
            {t(needsEnterprise ? "plan.limit.business_body" : "plan.limit.freelance_body")}
          </p>
        </div>
        <div className="rounded-sm border border-[var(--border)] bg-[var(--surface-elevated)] px-4 py-3 text-sm font-semibold text-[var(--text)]">
          {current} / {limit} {t(limit === 1 ? "plan.project_one" : "plan.project_many")}
        </div>
        <p className="text-xs leading-relaxed text-[var(--text-2)]">{t("plan.no_payment_note")}</p>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button type="button" onClick={onClose} className="rounded-sm border border-[var(--border)] px-4 py-2 text-sm font-semibold text-[var(--text)] hover:bg-[var(--surface-elevated)]">
            {t("plan.limit.close")}
          </button>
          <a href="/#pricing" className="btn-primary inline-flex items-center justify-center px-4 py-2 text-sm font-semibold">
            {t(needsEnterprise ? "plan.limit.enterprise_cta" : "plan.limit.business_cta")}
          </a>
        </div>
      </section>
    </div>
  );
}
